import {
  LeadScoreBadge as LeadScoreBadgeComponent,
  ILeadScoreBadgeProps as ILeadScoreBadgeComponentProps,
} from 'crono-fe-common/components/LeadScore/components/LeadScoreBadge';
import { LeadScoreDetailsContent } from './LeadScoreDetailsContent';
import { LeadScoreProperty } from 'crono-fe-common/types/leadScore';
import { ScoreSettingsTypes } from 'crono-fe-common/types/DTO/patchScoringSettings';
import { TLeadScore } from 'crono-fe-common/types/leadScore';
import { useRoleCapabilities } from 'hooks/useRoleCapabilities';
import {
  ControlledPopover,
  type OverlayPlacement,
  type OverlayProps,
} from 'components/Overlay';

type LeadScoreBadgeBaseType = ScoreSettingsTypes;

interface LeadScoreBadgeBaseProps {
  type: LeadScoreBadgeBaseType;
  size?: ILeadScoreBadgeComponentProps['size'];
  iconSize?: ILeadScoreBadgeComponentProps['iconSize'];
  scoreSettings?: { mediumScoreMin?: number; highScoreMin?: number } | null;
  scoreDetails?: TLeadScore['score'];
  scoreShort?: TLeadScore['score'];
  defaultProperties: LeadScoreProperty[];
  loading: boolean;
  refreshLoading: boolean;
  open: boolean;
  placement?: OverlayPlacement;
  /** From useTableOverlayProps when the badge sits in a table cell. */
  overlayProps?: OverlayProps;
  onRefresh: () => void;
  onSettings: () => void;
  onOpenChange: (open: boolean) => void;
}

export const LeadScoreBadgeBase = ({
  type,
  size,
  iconSize,
  scoreSettings,
  scoreDetails,
  scoreShort,
  defaultProperties,
  loading,
  refreshLoading,
  open,
  placement,
  overlayProps,
  onRefresh,
  onSettings,
  onOpenChange,
}: LeadScoreBadgeBaseProps) => {
  const mediumScore = scoreSettings?.mediumScoreMin ?? 0;
  const highScore = scoreSettings?.highScoreMin ?? 100;
  const { isManager } = useRoleCapabilities();

  return (
    <ControlledPopover
      placement={placement}
      overlayProps={overlayProps}
      closeWhenDetached
      open={open}
      onClose={() => onOpenChange(false)}
      className="max-h-75 w-109.5 max-w-109.5 gap-0 p-2 pr-0"
      content={
        <LeadScoreDetailsContent
          details={scoreDetails}
          mdScore={mediumScore}
          highScore={highScore}
          type={type}
          onRefresh={onRefresh}
          onSettings={onSettings}
          defaultProperties={defaultProperties}
          refreshLoading={refreshLoading}
          loading={loading}
          hideSettings={!isManager}
        />
      }
    >
      <LeadScoreBadgeComponent
        open={open}
        mdScore={mediumScore}
        highScore={highScore}
        details={scoreShort}
        type={type}
        size={size}
        onOpenChange={onOpenChange}
        iconSize={iconSize}
      />
    </ControlledPopover>
  );
};
